import styled from 'styled-components/macro'
import FieldHelp from '../FieldHelp'

const CheckboxFieldHelp = styled(FieldHelp)`
  width: 100%;
`

export default CheckboxFieldHelp
